import React, { useMemo } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import type { PermissionsWithTimezone } from '../../../common/types';
import type { OtherAndCurrentProjectCalendar } from '../../../common/utils/reusable-calendars/types';
import { HolidaysView } from './holidays';
import { Timezone } from './timezone';
import type { TimeZone } from './timezone/types';
import { WorkWeek } from './work-week';

type CalendarViewProps = {
	calendar: OtherAndCurrentProjectCalendar;
	permissionsWithTimezone: PermissionsWithTimezone;
};

export const CalendarView = ({ calendar, permissionsWithTimezone }: CalendarViewProps) => {
	const { id, timezoneId, workingTimes, holidays } = calendar;
	const { allTimezones } = permissionsWithTimezone;

	const timezone: TimeZone = useMemo(
		() => allTimezones.find((zone) => zone.value === timezoneId),
		[allTimezones, timezoneId],
	);

	return (
		<Container data-testid={`servicedesk-sla-settings.ui.calendars.calendar.details-${id}`}>
			<Timezone timezone={timezone} />
			<WorkWeek workingTimes={workingTimes} />
			<HolidaysView holidays={holidays} />
		</Container>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	margin: token('space.200', '16px'),
	paddingBottom: token('space.200', '16px'),
});
